<template>
<div class="chapter">
<div class="inner_page">
<a id="page_5">
<h2 class="sec_front">Timeline</h2>
<table class="table">
<tbody><tr>
<td class="td1">1862</td>
<td class="td2">Battle of Hampton Roads during the American Civil War; first clash between ironclads</td></tr>
<tr>
<td class="td1">1898</td>
<td class="td2">Loss of USS <em class="italic">Maine</em> in Havana, Cuba; beginning of the Spanish-American War</td>
</tr>
<tr>
<td class="td1">1904</td>
<td class="td2">Battle of the Yellow Sea between Japanese and Russian battle fleets</td>
</tr>
<tr>
<td class="td1">1905</td>
<td class="td2">Battle of Tsushima between Japanese and Russian battle fleets</td>
</tr>
<tr>
<td class="td1">1906</td>
<td class="td2">British HMS <em class="italic">Dreadnought</em> launched, commencing the era of big-gun battleships and the naval arms race</td>
</tr>
<tr>
<td class="td1">1907</td>
<td class="td2">The Great White Fleet circumnavigates the globe as a display of U.S. naval power</td>
</tr>
<tr>
<td class="td1">1914</td>
<td class="td2">Battle of the Falkland Islands between British battlecruisers and German cruisers</td>
</tr>
<tr>
<td class="td1">1916</td>
<td class="td2">Battle of Jutland between British and German battle fleets; history’s largest clash of battleships</td>
</tr>
<tr>
<td class="td1">1918</td>
<td class="td2">Sinking of the Austro-Hungarian SMS <em class="italic">Szent István</em> by an Italian torpedo vessel</td>
</tr>
<tr>
<td class="td1">1919</td>
<td class="td2">Scuttling of the bulk of the German battle fleet in Scapa Flow</td>
</tr>
<tr>
<td class="td1">1921</td>
<td class="td2">Sinking of decommissioned battleships in the U.S. by aircraft to demonstrate air power</td>
</tr>
<tr>
<td class="td1">1922</td>
<td class="td2">Washington Naval Treaty limited the size and armament of future battle fleets</td>
</tr>
<tr>
<td class="td1">Sept. 1939</td>
<td class="td2">German Pre-Dreadnought <em class="italic">Schleswig-Holstein</em> fires at the Polish Westerplatte starting World War II</td>
</tr>
<tr>
<td class="td1">Oct. 1939</td>
<td class="td2">Sinking of British HMS <em class="italic">Royal Oak</em> by German U-boat <em class="italic">U-47</em></td>
</tr>
<tr>
<td class="td1">Dec. 1939</td>
<td class="td2">Hunt for the German Panzerschiff <em class="italic">Admiral Graf Spee</em></td>
</tr>
<tr>
<td class="td1">July 1940</td>
<td class="td2">British naval attack on French fleet at Mers-el-Kébir</td>
</tr>
<tr>
<td class="td1"><a id="page_6">Nov. 1940</a></td>
<td class="td2">British aerial attack on Italian fleet at Taranto</td>
</tr>
<tr>
<td class="td1">May 1941</td>
<td class="td2">Battle of the Denmark Strait and the hunt for the German <em class="italic">Bismarck</em></td>
</tr>
<tr>
<td class="td1">Dec. 1941</td>
<td class="td2">Japanese Attack on Pearl Harbor</td>
</tr>
<tr>
<td class="td1">Dec. 1941</td>
<td class="td2">Sinking of HMS <em class="italic">Prince of Wales</em> and HMS <em class="italic">Repulse</em></td>
</tr>
<tr>
<td class="td1">Sept. 1943</td>
<td class="td2">Sinking of the Italian <em class="italic">Roma</em></td>
</tr>
<tr>
<td class="td1">Dec. 1943</td>
<td class="td2">Sinking of the German <em class="italic">Scharnhorst</em></td>
</tr>
<tr>
<td class="td1">June 1944</td>
<td class="td2">Allied landings in Normandy</td>
</tr>
<tr>
<td class="td1">Oct. 1944</td>
<td class="td2">Last battleship-to-battleship clash in Surigao Strait</td>
</tr>
<tr>
<td class="td1">Nov. 1944</td>
<td class="td2">Sinking of the German <em class="italic">Tirpitz</em></td>
</tr>
<tr>
<td class="td1">1944/45</td>
<td class="td2">Sinking of the Japanese <em class="italic">Musashi</em> and <em class="italic">Yamato</em>, the largest battleships ever built</td>
</tr>
<tr>
<td class="td1">1945</td>
<td class="td2">Japanese surrender aboard the USS <em class="italic">Missouri</em> ending World War II</td>
</tr>
<tr>
<td class="td1">1946</td>
<td class="td2">Operation <em class="italic">Crossroads;</em> nuclear weapon tests conducted by the U.S. at Bikini Atoll</td>
</tr>
<tr>
<td class="td1">1950</td>
<td class="td2">Battleship gunfire support during the Korean War</td>
</tr>
<tr>
<td class="td1">1968</td>
<td class="td2">Battleship gunfire support during the Vietnam War</td>
</tr>
<tr>
<td class="td1">1982</td>
<td class="td2"><em class="italic">“Comeback”</em> of the battleship</td>
</tr>
<tr>
<td class="td1">1991</td>
<td class="td2">Battleship gunfire support during Operation <em class="italic">Desert Storm</em></td>
</tr>
<tr>
<td class="td1">1992</td>
<td class="td2">Final decommissioning of the USS <em class="italic">Missouri,</em> the world’s last active battleship</td>
</tr></tbody></table></a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_Timeline.vue?1c58aa16